import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { css } from 'emotion';
import { Link } from '@guardian/src-link';
import { Button } from '@guardian/src-button';
import { text } from '@guardian/src-foundations/palette';
import { textSans } from '@guardian/src-foundations/typography';
import { FileUpload } from './FileUpload';
import { MultiSelect } from './MultiSelect';
import { Select } from './Select';
import { TextArea } from './TextArea';
import { TextInput } from './TextInput';
const formStyles = css `
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding-left: 10px;
	padding-right: 10px;
`;
const footerPaddingStyles = css `
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding-bottom: 15px;
`;
const errorMessagesStyles = css `
	padding-bottom: 10px;
	color: ${text.error};
	${textSans.medium({ fontWeight: 'bold' })};
`;
const formFieldWrapperStyles = css `
	display: flex;
	flex-direction: column;
`;
const FormField = ({ formField, formData, setFormData }) => {
    switch (formField.type) {
        case 'textarea':
            return (_jsxs(_Fragment, { children: [_jsx(TextArea, { formField: formField, formData: formData, setFormData: setFormData }, void 0),
                    _jsx("hr", {}, void 0)] }, void 0));
        case 'file':
            return (_jsxs(_Fragment, { children: [_jsx(FileUpload, { formField: formField, formData: formData, setFormData: setFormData }, void 0),
                    _jsx("hr", {}, void 0)] }, void 0));
        case 'select':
            return (_jsxs(_Fragment, { children: [_jsx(Select, { formField: formField, formData: formData, setFormData: setFormData }, void 0),
                    _jsx("hr", {}, void 0)] }, void 0));
        case 'checkbox':
        case 'radio':
            return (_jsxs(_Fragment, { children: [_jsx(MultiSelect, { formField: formField, formData: formData, setFormData: setFormData, multiple: formField.type === 'checkbox' }, void 0),
                    _jsx("hr", {}, void 0)] }, void 0));
        default: {
            return (_jsxs(_Fragment, { children: [_jsx(TextInput, { formField: formField, formData: formData, setFormData: setFormData }, void 0),
                    _jsx("hr", {}, void 0)] }, void 0));
        }
    }
};
export const Form = ({ onSubmit, formFields, error }) => {
    const [twitterHandle, setTwitterHandle] = useState('');
    const [formData, setFormData] = useState({});
    return (_jsxs("form", Object.assign({ action: "/formstack-campaign/submit", method: "post", className: formStyles, onSubmit: (e) => {
            e.preventDefault();
            onSubmit(formData);
        } }, { children: [formFields.map((formField, index) => (_jsx("div", Object.assign({ className: formFieldWrapperStyles, "custom-guardian": "callout-form-field" }, { children: _jsx(FormField, { formField: formField, formData: formData, setFormData: setFormData }, void 0) }), index))),
            _jsx("div", Object.assign({ className: css `
					position: absolute;
					left: -62.5rem;
				`, "aria-hidden": "true" }, { children: _jsx("input", { name: "twitter-handle", type: "text", id: "twitter-handle", tabIndex: -1, placeholder: "@mytwitterhandle", value: twitterHandle, onChange: (e) => setTwitterHandle(e.target.value) }, void 0) }), void 0),
            error && _jsx("div", Object.assign({ className: errorMessagesStyles }, { children: error }), void 0),
            _jsxs("div", Object.assign({ className: footerPaddingStyles }, { children: [_jsx(Button, Object.assign({ priority: "secondary", size: "xsmall", type: "submit" }, { children: "Share with the Guardian" }), void 0),
                    _jsx("div", Object.assign({ className: css `
						a,
						a:hover {
							border: 0;
						}
						text-align: right;
					` }, { children: _jsx(Link, Object.assign({ subdued: true, priority: "secondary", target: "_blank", href: "https://www.theguardian.com/help/terms-of-service" }, { children: "Terms and conditions" }), void 0) }), void 0)] }), void 0)] }), void 0));
};
